import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeroBanner from '../components/common/HeroBanner/HeroBanner';

const BlogSingle = () => {
  const { id } = useParams();
  
  useEffect(() => {
    document.title = 'NEST | Blog Post';
  }, []);
  
  return (
    <div>
      <HeroBanner 
        title="Blog Post" 
        breadcrumbs={['Blog', 'Post']}
      />
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-md-7 heading-section text-center ftco-animate">
              <h2>Blog Post {id}</h2>
              <p>Content coming soon.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogSingle;


